import { customAlphabet } from "nanoid/non-secure";
export const generateId = customAlphabet("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz", 7);
//# sourceMappingURL=generateId.js.map